function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var saito = require('./../../lib/saito/saito');
var TeaserModule = require('./lib/teasermodule');
var ModTemplate = require('../../lib/templates/modtemplate');
var JSON = require('json-bigint');
var Teasers = /*#__PURE__*/function (_ModTemplate) {
  function Teasers(app) {
    var _this;
    _classCallCheck(this, Teasers);
    _this = _callSuper(this, Teasers, [app]);
    _this.name = 'Teasers';
    _this.slug = 'teasers';
    _this.appname = 'Teasers';
    _this.description = 'Teaser Applications for the Arcade / Appstore';
    _this.categories = 'Finance Utilities';
    _this.icon = 'fas fa-wallet';
    _this["class"] = 'utility';
    _this.status = 'beta';
    _this.teasers = [{
      name: 'HereIStand',
      slug: 'his',
      img: '/his/img/arcade/arcade.jpg',
      title: 'Here I Stand',
      link: 'https://wiki.saito.io/applications/his'
    }, {
      name: 'Paths',
      slug: 'paths',
      img: '/paths/img/arcade/arcade.jpg',
      title: 'Paths of Glory',
      link: 'https://wiki.saito.io/applications/paths'
    }, {
      name: 'Twilight',
      slug: 'twilight',
      img: '/twilight/img/arcade/arcade.jpg',
      title: 'Twilight',
      link: 'https://wiki.saito.io/applications/twilight'
    }, {
      name: 'Imperium',
      slug: 'imperium',
      img: '/imperium/img/arcade/arcade.jpg',
      title: 'Red Imperium',
      link: 'https://wiki.saito.io/applications/imperium'
    }
    /****
    { name : "Blackjack" , slug : "blackjack" , img : "/blackjack/img/arcade/arcade.jpg" , title : "Blackjack" , link : "https://wiki.saito.io/tech/applications/blackjack" } ,
    { name : "Chess" , slug : "chess" , img : "/chess/img/arcade/arcade.jpg" , title : "Chess" , link : "https://wiki.saito.io/tech/applications/chess" }     ,
    { name : "Hearts" , slug : "hearts" , img : "/hearts/img/arcade/arcade.jpg" , title : "Hearts" , link : "https://wiki.saito.io/tech/applications/hearts" }      ,
    { name : "Quake3" , slug : "quake3" , img : "/quake3/img/arcade/arcade.jpg" , title : "Quake3" , link : "https://wiki.saito.io/tech/applications/quake3" }      ,
    { name : "Poker" , slug : "poker" , img : "/poker/img/arcade/arcade.jpg" , title : "Poker" , link : "https://wiki.saito.io/tech/applications/poker" }     ,
    { name : "SaitoMania" , slug : "saitomania" , img : "/saitomania/img/arcade/arcade.jpg" , title : "Saito Mania" , link : "https://wiki.saito.io/tech/applications/saitomania" } ,
    { name : "Scotland" , slug : "scotland" , img : "/scotland/img/arcade/arcade.jpg" , title : "Scotland" , link : "https://wiki.saito.io/tech/applications/scotland" }    ,
    { name : "Settlers" , slug : "settlers" , img : "/settlers/img/arcade/arcade.jpg" , title : "Settlers" , link : "https://wiki.saito.io/tech/applications/settlers" }    ,
    { name : "Shogun" , slug : "shogun" , img : "/shogun/img/arcade/arcade.jpg" , title : "Shogun" , link : "https://wiki.saito.io/tech/applications/shogun" }      ,
    { name : "Solitrio" , slug : "solitrio" , img : "/solitrio/img/arcade/arcade.jpg" , title : "Solitrio" , link : "https://wiki.saito.io/tech/applications/solitrio" }    ,
    { name : "Spider" , slug : "spider" , img : "/spider/img/arcade/arcade.jpg" , title : "Spider" , link : "https://wiki.saito.io/tech/applications/spider" }      ,
    { name : "Thirteen" , slug : "thirteen" , img : "/thirteen/img/arcade/arcade.jpg" , title : "Thirteen" , link : "https://wiki.saito.io/tech/applications/thirteen" }    ,
    
    { name : "Wordblocks" , slug : "wordblocks" , img : "/wordblocks/img/arcade/arcade.jpg" , title : "Wordblocks" , link : "https://wiki.saito.io/tech/applications/wordblocks" }  ,
    { name : "Wuziqi" , slug : "wuziqi" , img : "/wuziqi/img/arcade/arcade.jpg" , title : "Wuziqi" , link : "https://wiki.saito.io/tech/applications/wuziqi" }      ,
    ***/];
    return _this;
  }
  _inherits(Teasers, _ModTemplate);
  return _createClass(Teasers, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var z, t, install_this, zz, dupe_mod, i, tm;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _superPropGet(Teasers, "initialize", this, 3)([app]);
            case 1:
              if (!app.BROWSER) {
                _context.n = 5;
                break;
              }
              z = 0;
            case 2:
              if (!(z < this.teasers.length)) {
                _context.n = 5;
                break;
              }
              t = this.teasers[z];
              install_this = true;
              for (zz = 0; zz < app.options.modules.length; zz++) {
                if (app.options.modules[zz].name == t.name) {
                  install_this = false;
                }
              }
              if (!(install_this == true)) {
                _context.n = 4;
                break;
              }
              dupe_mod = false;
              for (i = 0; i < this.app.options.modules.length; i++) {
                if (this.app.options.modules[i].name === t.name) {
                  dupe_mod = true;
                }
              }
              if (!(dupe_mod == false)) {
                _context.n = 4;
                break;
              }
              console.log('**** adding teaser: ' + t.name);
              tm = new TeaserModule(this.app, t.name, t.slug, t.title, t.img, t.link);
              tm.img = t.img;
              tm.is_teaser = true;
              _context.n = 3;
              return tm.installModule(app);
            case 3:
              app.modules.mods.push(tm);
            case 4:
              z++;
              _context.n = 2;
              break;
            case 5:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }]);
}(ModTemplate);
module.exports = Teasers;